<template>
	<div class="display-flex gap-100 p-100">
		<div class="asset-element-card-content mr-auto">
			<div :title="name" class="body-lg line-clamp-2 font-weight-bold mt-25">{{ name }}</div>
			<Tag :text="assetType" class="mt-100" />
		</div>
		<img
			v-if="thumbnailPhoto"
			v-lazy="thumbnailPhoto"
			alt=""
			role="presentation"
			:class="['img-rounded order-1-smo', imageClass]"
		/>
	</div>
</template>

<script setup lang="ts">
import { Asset } from 'types/assets';
import { computed } from 'vue';
import Tag from '@components/tags/tag-component.vue';

interface Props {
	assetElement: Asset;
}

const props = defineProps<Props>();

const assetType = computed((): string => props.assetElement.assetType.name);

const isThumbnailSquare = computed((): boolean => !!props.assetElement.thumbnailSquare);

const imageClass = computed((): string =>
	isThumbnailSquare.value ? 'asset-element-card-image__square' : 'asset-element-card-image'
);

const name = computed((): string => props.assetElement.name ?? props.assetElement.assetType.name);

const thumbnailPhoto = computed((): string => props.assetElement.thumbnail?.url ?? '');
</script>

<style lang="scss" scoped>
.asset-element-card {
	&-content {
		min-width: 0;
	}

	&-image {
		height: 5.625rem;
		min-width: 7.5rem;
		width: 7.5rem;

		&__square {
			height: 5.625rem;
			min-width: 5.625rem;
			width: 5.625rem;
		}
	}

	.tag {
		display: inline-block;
	}
}
</style>
